export const StartParamsCodes = {
  DEBUG: "debug",
  REFERRER_ADDRESS: "ref",
  BUY: "buy",
} as const;
